import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserVideoServices } from 'src/app/services/user/user-video-services';
import { SubSink } from 'subsink';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api/api.service';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { Browser } from '@capacitor/browser';
import { AdsService } from 'src/app/services/ads/ads.service';
import { PlatformService } from 'src/app/services/platform/platform.service';


@Component({
  selector: 'app-video-detail',
  templateUrl: './video-detail.page.html',
  styleUrls: ['./video-detail.page.scss'],
})
export class VideoDetailPage implements OnInit {
  showMe: boolean = false;
  moment: any = moment;
  subscription = new SubSink();
  video: any;
  bucket_url = environment.s3_bucket_url;
  recordId: any = 0;
  btnShow = true;
  purchased_videos: any = [];
  paymentHandler: any = null;
  logged_user_id: string = '';
  showPlayButton: boolean = false;
  receiver_id: string = null;
  ad_image: any;
  allowOver21Ads: boolean = false;
  isiOSApp: boolean;

  constructor(
    private userVideo: UserVideoServices,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private http: HttpClient,
    private adsService: AdsService,
    private platform: PlatformService
  ) {
    this.isiOSApp = this.platform.isiOSApp();
    if(localStorage.getItem("user_profile")){
      this.logged_user_id = JSON.parse(localStorage.getItem("user_profile")).id
    }
  }

  async ngOnInit() {
    // this.recordId = this.route.snapshot.paramMap.get('id');
    // await this.getVideoDetail(this.recordId);
  }

  async ionViewWillEnter(){
    // console.log("date time", moment().format());
    this.invokeStripe();
    this.recordId = atob(this.route.snapshot.paramMap.get('id')!);
    // console.log("record Id", this.recordId);
    this.isiOSApp ? this.getStoredAgeStorageValue() : this.getStoredCookieValue();
    this.getFilteredAdRight();
    await this.getVideoDetail(this.recordId);
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  // ionViewDidEnter(){
  //   const script = window.document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.innerHTML = `googletag.cmd.push(function() {
  //     googletag.display('div-1');
  //   });`
  //   window.document.body.appendChild(script);
  // }

  getStoredCookieValue(): boolean {
    // console.log("stored cookie ==> ",this.getCookie('allowOver21Ads'));
    let stored_cookie = this.getCookie('allowOver21Ads');
    if (stored_cookie == 'true')
      return this.allowOver21Ads = true;
    else
      return this.allowOver21Ads = false;
  }

  getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1)
          c_end = document.cookie.length;
        // console.log("cookie ===> ",unescape(document.cookie.substring(c_start, c_end)));
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }

  getStoredAgeStorageValue(): boolean {
    return JSON.parse(localStorage.getItem('allowOver21Ads'));
  }

  hasStoredAgeStorageValue(): boolean {
    let ageStorageKey = JSON.parse(localStorage.getItem('allowOver21Ads'));
    if (ageStorageKey === undefined || ageStorageKey === null) {
      return false;
    } else {
      return true;
    }
  }

  getFilteredAdRight() {
    let positions_arr = ['right'];
    this.subscription.sink = this.adsService._adsStatus.subscribe((value) => {
      if (this.hasStoredAgeStorageValue() || this.getCookie('allowOver21Ads')) {
        let data = {
          positions: positions_arr,
          allowOver21Ads: this.isiOSApp ? this.getStoredAgeStorageValue() : this.getStoredCookieValue()
        }
        this.http.post(`${environment.base_url}ads/filter-ads`, data)
          .subscribe(
            (res: any) => {
              console.log("response =====> ",res.data.ad_images);
              this.ad_image = res.data.ad_images[0];
              console.log(this.ad_image?.s3_uid);
              // console.log("length ==> ",this.ad_images.length);
            },
            (err: any) => {
              console.log(err);
            }
          );
      }

    });

  }

  async redirectToURL(url) {
    // console.log("url ===> ",url);
    if(url.length > 0) {
      await Browser.open({ url: url });
    }
  }

  hide(){
    this.showMe = !this.showMe;
  }
  getVideoDetail(id){
    this.subscription.sink = this.userVideo.getVideoDetail(id).subscribe(
      async (video: any) => {
        this.video = video.detail.data;
        this.receiver_id = this.video.user_id;
        if(this.video){
          let currentDateTime = moment().format("YYYY-MM-DD HH:mm");
          let startDateTime = this.video.video_release_date + ' ' + this.video.video_release_time;
          let endDateTime = this.video.video_release_end_date + ' ' + this.video.video_release_end_time;
          this.showPlayButton = moment(startDateTime).isBefore(currentDateTime) &&  moment(endDateTime).isAfter(currentDateTime);
        }
        if(video.purchased_videos.length > 0){
          this.purchased_videos = video.purchased_videos.map(item => {
            return item.video_id
          })
        }
        return true;
      },
      (error) => console.log(error)
    );
  }
  playVideo(item){
    if(this.purchased_videos.includes(item.id) || item.video_type == 'public' || this.logged_user_id == item.user_id){
      var video = document.getElementById('my-video') as HTMLVideoElement;
      video.play();
      video.setAttribute("controls", "true");
      this.btnShow = false;
      if(localStorage.getItem("user_data")){
        // console.log("localStorage is set and user is logged in");
        let data = {
          video_id: this.video.id,
          is_viewed: true,
        }
        this.apiService.post('users/addVideoStats', data).subscribe((res) => {
          // console.log("stats added...");
        });
      }
    }else{
      this.makePayment(item.view_cost, item.id)
      // console.log("please purchase video first");
    }

  }
  invokeStripe() {
    // console.log("invoke strip");
    if (!window.document.getElementById('stripe-script')) {
      // console.log("create strip script");
      const script = window.document.createElement('script');

      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          key: environment.stripe_key,
          locale: 'auto',
          token: function (obj: any) {
            // console.log("invokeStripe", obj);
            // alert('Payment has been successfully!');
          },
        });
      };

      window.document.body.appendChild(script);
    }
  }

  makePayment(amount: any, video_id) {
    let myThis = this;
    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: environment.stripe_key,
      locale: 'auto',
      token: function (stripeToken: any) {
        let data = {
          amount: amount,
          token: stripeToken.id,
          video_id: video_id,
          receiver_id: myThis.receiver_id,
          email: stripeToken.email,
        }
        // console.log("makePayment", stripeToken);
        myThis.apiService.post('checkout', data).subscribe((res) => {
          myThis.apiService.post('checkout/user-videos', data).subscribe((resp) => {
            // console.log("response from server is", resp);
            // console.log("Payment Done")
            myThis.purchased_videos.push(video_id);
          });
        });
      },
    });

    paymentHandler.open({
      name: 'Local & Live',
      description: 'Stripe Payment',
      amount: amount * 100,
      closed: function(){
        // console.log("popup of stripe checkout closed.")
      },
    });
  }

}
